import { ReactNode } from 'react';
import { FieldHelp } from './FieldHelp';
import { RequiredMark } from './RequiredMark';

type FieldLabelProps = {
  children: ReactNode;
  description?: string;
  example?: string;
  required?: boolean;
};

export function FieldLabel({ children, description, example, required = false }: FieldLabelProps) {
  return (
    <span className="inline-flex items-center gap-1">
      {children}
      {required ? <RequiredMark /> : null}
      {description ? <FieldHelp description={description} example={example} /> : null}
    </span>
  );
}
